// extracted by mini-css-extract-plugin
var _1 = "TopicPosts-module__animateUploadProgressBarWidth--yaI_e";
var _2 = "TopicPosts-module__animatedBackground--chED8";
var _3 = "TopicPosts-module__isEditing--zwxXd";
var _4 = "TopicPosts-module__subtopicHeader--DuSMq";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "isEditing", _4 as "subtopicHeader" }
